import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled.div`
  padding: 8px 40px;
  background-color: ${theme.colors.neutral.white};
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const ColDivider = styled.div`
  height: 20px;
  width: 1px;
  margin: 0 ${theme.spacing.xm};
  background-color: ${theme.colors.primary[90]};
`
